// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/modules/language/language.less
 ** module id = 42
 ** module chunks = 0
 **/